export interface PeerReviewDraft {
  dimensionOneStars: number;
  dimensionTwoStars: number;
  dimensionThreeStars: number;
  commentTemplate: string;
}

export interface ViewerPeerReview {
  dimensionOneStars: number;
  dimensionTwoStars: number;
  dimensionThreeStars: number;
  commentTemplate: string;
}

const EMPTY_PEER_REVIEW_DRAFT: PeerReviewDraft = {
  dimensionOneStars: 0,
  dimensionTwoStars: 0,
  dimensionThreeStars: 0,
  commentTemplate: '',
};

export const syncPeerReviewDraft = ({
  currentDraft,
  viewerReview,
  silent,
}: {
  currentDraft: PeerReviewDraft;
  viewerReview: ViewerPeerReview | null;
  silent: boolean;
}): PeerReviewDraft => {
  if (!viewerReview) {
    return silent ? currentDraft : EMPTY_PEER_REVIEW_DRAFT;
  }

  return {
    dimensionOneStars: viewerReview.dimensionOneStars,
    dimensionTwoStars: viewerReview.dimensionTwoStars,
    dimensionThreeStars: viewerReview.dimensionThreeStars,
    commentTemplate: viewerReview.commentTemplate,
  };
};
